module.exports = __webpack_public_path__ + "img/daichao1.688511a4.png";